import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import IntelligenceHero from "../sections/IntelligenceHero";
import IntelligenceServices from "../sections/IntelligenceServices";
import "./GrowthPage.css";

export default function IntelligencePage() {
  return (
    <>
      <Navbar />
      <main className="growth-main">
        <IntelligenceHero />
        <IntelligenceServices />
      </main>
      <Footer />
    </>
  );
}
